export enum AddressIconOption {
    MAP_PIN = 'map_pin',
    ORDER = 'order',
    CART = 'cart',
    DELIVERY = 'delivery',
    STAR = 'star',
    DRONE = 'drone',
    CALENDAR = 'calendar',
    FIRE = 'fire',
    HEART = 'heart',
    CURRENT_LOCATION = 'current_location',
    OTHER = 'other',
}
